import { render, staticRenderFns } from "./VaultController.vue?vue&type=template&id=a7513a66&scoped=true&"
import script from "./VaultController.vue?vue&type=script&lang=ts&"
export * from "./VaultController.vue?vue&type=script&lang=ts&"
import style0 from "./VaultController.vue?vue&type=style&index=0&id=a7513a66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7513a66",
  null
  
)

export default component.exports